<template>
  <div
    v-if="visible"
    class="fixed inset-0 z-60 flex items-center justify-center bg-transparent"
  >
    <div
      class="fixed top-0 z-10 h-full w-full bg-dark-gray bg-opacity-50"
      @click="$emit('close')"
    ></div>
    <div
      class="relative z-10 w-full scroll-auto rounded-t-lg bg-white p-2"
      :class="{
        'mt-12 h-full': isFullScreen,
        [`mt-auto ${minHeight}`]: !isFullScreen,
        'm-auto max-w-[600px] rounded-b-lg': !isMobile,
      }"
    >
      <div v-if="showCloseIcon">
        <img
          class="absolute top-4 z-20 h-4 w-4 cursor-pointer"
          :class="{
            'right-5': closeIconRightAlign,
            'left-5': !closeIconRightAlign,
          }"
          src="@/assets/close-icon.svg"
          alt="close icon"
          @click="$emit('close')"
        />
      </div>

      <div class="h-full overflow-y-scroll pt-8">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useScreenSize } from '@/composables/useScreenSize';

export default {
  name: 'BottomSheet',
  props: {
    visible: Boolean,
    isFullScreen: Boolean,
    showCloseIcon: {
      type: Boolean,
      default: true,
    },
    minHeight: {
      type: String,
      default: 'min-h-[300px]',
    },
    closeIconRightAlign: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  setup() {
    const { screenSize } = useScreenSize();

    const isMobile = computed(() => screenSize.value === 'mobile');

    return {
      isMobile,
    };
  },
};
</script>
